<template>
	<div 
		ref="popupRef"
		class="absolute bg-background rounded-md p-2 pointer-events-none z-10" 
		:style="popupPosition"
	>
		<div 
			class="font-bold"
			:style="{ color: uaqiColorsBright[region.level]}"
		>
			{{ region.name }}
		</div>
		<small>{{ uaqiDescriptions[region.level].name }}</small>
	</div>
</template>

<script setup>
import { computed, defineProps, ref, onMounted } from 'vue'
import { uaqiColorsBright, uaqiDescriptions } from '@/modules/UAQI.js'

defineProps({
	region: Object
})

import { useMouse } from '@vueuse/core'

const { x, y } = useMouse({ touch: false })

const parentWidth = ref(0)
const popupRef = ref(null)

const offsetX = 20
const offsetY = 60

const popupPosition = computed(() => {
	if (!x || !y || !popupRef.value) {
		return {}
	}

	let leftPosition = x.value + offsetX

	const popupWidth = popupRef.value.offsetWidth;

	// Check whether the pop -up window does not go beyond the right edge
	if (leftPosition + popupWidth + 20 > parentWidth.value) { 
		leftPosition = x.value - popupWidth - offsetX
	}

	return {
		top: `${y.value - offsetY}px`,
		left: `${leftPosition}px`,
	}
})

onMounted(() => {
	if (document.documentElement) {
		parentWidth.value = document.documentElement.clientWidth
	}
})
</script>

<style scoped>

</style>